import "core-js/modules/es.object.assign.js";
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { useTheme } from 'styled-components';
import { LongArrowRight } from '@finect/tabular-icons/longArrowRight';
import { AppLink } from '@finect/tabular-core/AppLink';
import { getImageUrl } from '../../Image/utils';
import { Inner, Cover, Content, Title, Subtitle, Action } from './partials';
export var BottomOutsideTitleCard = function BottomOutsideTitleCard(_ref) {
  var title = _ref.title,
    subtitle = _ref.subtitle,
    link = _ref.link,
    cta = _ref.cta,
    color = _ref.color,
    backgroundColor = _ref.backgroundColor,
    backgroundImage = _ref.backgroundImage,
    onClick = _ref.onClick,
    _ref$compact = _ref.compact,
    compact = _ref$compact === void 0 ? true : _ref$compact;
  var theme = useTheme();
  var innerProps = onClick ? {
    as: 'div',
    onClick: onClick
  } : {
    href: link
  };
  var ctaProps = onClick ? {
    href: '#'
  } : {
    as: 'span'
  };
  var image = getImageUrl(backgroundImage, {
    height: 180
  });
  return React.createElement(Inner, _extends({
    "data-fi-event": link
  }, innerProps), React.createElement(Cover, {
    backgroundImage: image,
    backgroundColor: backgroundColor
  }), React.createElement(Content, {
    color: color || theme.colors.font,
    isCompact: compact
  }, React.createElement(Title, null, title), React.createElement(Subtitle, null, subtitle), cta ? React.createElement(Action, null, React.createElement(AppLink, ctaProps, cta, React.createElement(LongArrowRight, {
    size: "18px",
    strokeWidth: "3"
  }))) : null));
};